<template>
    <v-row class="ma-0">
      <v-col class="px-1 py-0" cols="6">
        <v-row class="mx-0 mb-0 mt-2 pr-8">
          <v-col class="text-list text-center px-0 pt-0 pb-2"
            ><small>Vl. glosado (R$):</small><br /><b>{{
              info.valor_glosado ? info.valor_glosado
                : 0 | formatPrice
            }}</b></v-col
          >
          <v-col class="text-list text-center px-0 pt-0 pb-2"
            ><small>Vl. analisado (R$):</small><br /><b>{{
              info.valor_analisado
                ? info.valor_analisado
                : 0 | formatPrice
            }}</b></v-col
          >
          <v-col class="text-list text-center px-0 pt-0 pb-2"
            ><small>Vl. recursado (R$):</small><br /><b style="color: green">{{
              info.valor_recursado
                ? info.valor_recursado
                : 0 | formatPrice
            }}</b></v-col
          >
          <v-col class="text-list text-center px-0 pt-0 pb-2"
            ><small>Vl. acatado (R$):</small><br /><b
              ><span style="color: red">{{
                info.valor_acatado
                  ? info.valor_acatado
                  : 0 | formatPrice
              }}</span></b
            ></v-col
          >
        </v-row>
      </v-col>
      <v-col class="px-4 pt-2 pb-5" cols="6">
        <v-progress-linear
          :value="info.porc_analisados"
          color="primary"
        ></v-progress-linear>
        <v-row class="pt-4 px-2">
          <v-col class="px-2 py-0" cols="6">
            <small class="mt--1 text--secondary d-flex justify-start">
            Analisado:&nbsp;
            <b> {{ info.qtd_guia_com_analise }}
              {{ info.qtd_guia_com_analise > 1 ? "guias" : "guia" }} /
              {{ info.qtd_item_com_analise }}
              {{info.qtd_item_com_analise > 1 ? "itens" : "item"}}</b
            >
            ({{ info.porc_analisados | formatPrice }}%)
            </small>
          </v-col>
          <v-col class="text-right px-2 py-0" cols="6">
            <small class="mt--1 text--secondary d-flex justify-end">
            Aguardando análise:&nbsp;
            <b> {{ info.qtd_guia_total - info.qtd_guia_com_analise - info.qtd_guia_concluida }} 
                {{info.qtd_guia_total - info.qtd_guia_com_analise - info.qtd_guia_concluida > 1 
                  ? "guias"
                  : "guia"
              }}
              /
              {{ info.qtd_item_total - (info.qtd_item_com_analise + info.qtd_item_concluido) }}
              {{ info.qtd_item_total - (info.qtd_item_com_analise + info.qtd_item_concluido)> 1
                  ? "itens"
                  : "item"
              }}</b>
            </small>
          </v-col>
          <v-col class="text-right px-2 py-0" cols="12">
            <small class="text--secondary d-flex justify-center">
              Enviado:&nbsp;
              <b> {{info.qtd_guia_concluida}}
                  {{ info.qtd_guia_concluida > 1 
                  ? "guias"
                  : "guia"}}
                /
                {{info.qtd_item_concluido}}
                {{ info.qtd_item_concluido > 1
                  ? "itens"
                  : "item"}}
              </b>
            </small>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
</template>

<script>

export default {
   props: {
    info: Object
  },
};
</script>